import { cloneDeep } from "lodash";
import store from "../redux/store";
import { BRANCH_STATUS_MAP, COMPONENT_MODES } from "../data/constants";

/**
 * This function will return the categoryToItemMap and map for menu items
 * @param {*} menuItems 
 */
export function getCategoryItemsMap(menuItems) {
  const catItemMap = {}, menuItemsMap = {}, menuItemWithName = {};
  for (var i = 0, len = menuItems.length; i < len; i++) {
    //catId will be the category ID we will check if subCat on an Item exist then we will push the item to subCat instead of parentCat
    const data = menuItems[i], catId = data.info.subCategoryId ? data.info.subCategoryId : data.info.categoryId, parentCatId = data.info.categoryId;
    menuItemsMap[data.mid] = data;
    menuItemWithName[data?.info?.shortName || data.mid] = data;
    if (catItemMap[catId]) { // if item is present in map
      catItemMap[catId].itemIDs.push(data.mid);
      catItemMap[catId].itemCount += 1;
    }
    else {
      catItemMap[catId] = {
        itemIDs: [data.mid],
        itemCount: 1
      };
    }
    /*
      * this logic will help in updating the itemCount for parent cat, if the item is pushed to subcategory then also the 
      * itemCount of parentCategory should also increment 
    */
    if (catId !== parentCatId) {
      if (catItemMap[parentCatId])
        catItemMap[parentCatId].itemCount += 1;
      else
        catItemMap[parentCatId] = {
          itemIDs: [],
          itemCount: 1
        }
    }
  }
  return { catItemMap, menuItemsMap, menuItemWithName };
}

export const sortByDisplayOrder = (ipArr) => {
  let sortedMap = {}, count = 0;
  for (let item of ipArr) {
    const itemOrder = item.displayOrder || `displayOrder${count++}`;
    if (sortedMap[itemOrder])
      sortedMap[itemOrder].push(item);
    else
      sortedMap[itemOrder] = [item];
  }
  return Object.values(sortedMap).flat();
};

/**
 * This function will sort the categories and the sub categories in ascending order by displayorder key
 * @param {*} categoriesList 
 */
export function sortCategories(categoriesList) {
  let catList = cloneDeep(categoriesList);
  // this function will return the sorted array based on displayOrderKey. It will create a sorted map based upon display order and then fetch the values from the map
  const newCatList = sortByDisplayOrder(catList);
  newCatList.forEach(element => {
    if (element.subCategories && element.subCategories.length) {
      const sortedSubCats = sortByDisplayOrder(element.subCategories);
      element.subCategories = sortedSubCats;
    }
  });
  return newCatList;
}

/**
 * This will loop over the object and it will return the ar
 * @param {*} dataToTransform : it will be an object with keys as a string and values as an array of objects
 */
export function transformDataIntoMap(dataToTransform) {
  const tranformedData = {};
  for (let key in dataToTransform) {
    tranformedData[key] = convertArrayToObject(dataToTransform[key], key === "channelvos" ? "channelId" : "mid");
  }
  return tranformedData;
}

/**
 * deprecated- use convertArrayToObject from common-helpers.ts
 * This function will convert array to object using key
 * @param {*} inputArr 
 */
export function convertArrayToObject(inputArr, uniqueKey = 'mid', convertLowerCase = true) {
  if (inputArr?.constructor !== Array) return {};
  const lowerCase = (key) => {
    if (!convertLowerCase) return key;
    return key && key.toLocaleLowerCase();
  }
  return inputArr.reduce((acc, cur) => ({ ...acc, [lowerCase(cur[uniqueKey])]: cur }), {});
}

/**
 * This function will convert an array to an object and if the unique key has multiple items then it will add them in an array
 * @param {*} inputArr 
 * @param {*} uniqueKey 
 */
export function groupDataByKey(inputArr = [], uniqueKey = "groupId") {
  const lowerCase = (key) => key && key.toLocaleLowerCase();
  const hashMapData = {};
  inputArr.map((data) => {
    const hashMapKey = lowerCase(data[uniqueKey]);
    if (hashMapData[hashMapKey])
      hashMapData[hashMapKey].push(data);
    else
      hashMapData[hashMapKey] = [data];
  });
  return hashMapData;
}

/**
 * This function will return the data (list of items) from catalog Data map. It will parse over the listOfIds and search it in the catalogDataMap present in
 * reducer using keyToSearch
 * @param {*} listOfIds : it could be a list or a string
 * @param {*} keyToSearch : it will a key present in the catalogDataMap
 */
export function getDataByUniqueId(listOfIds, keyToSearch) {
  const catalogDataMap = store.getState().catalogReducer?.allCatalogDataMap || {};
  const resutls = [];
  if (Array.isArray(listOfIds))
    listOfIds.length && listOfIds.forEach((id) => {
      resutls.push(catalogDataMap[keyToSearch][id].mid);
    });
  else if (listOfIds)
    resutls.push(catalogDataMap[keyToSearch][listOfIds].mid);
  return resutls;
}

/**
 * This function will parse over the array and extract the unique mid's from it and returns
 * @param arrToParse 
 */
export function extractUniqueId(arrToParse) {
  const uniqueIdList = [];
  arrToParse.forEach((items) => {
    uniqueIdList.push(items.mid);
  });
  return uniqueIdList;
}

export function createItemExtrasMap(dataToTransform) {
  return dataToTransform.reduce((acc, cur) => ({ ...acc, [cur.config.name]: cur }), {});
}

export function isEditMode(mode) {
  return mode === COMPONENT_MODES.editMode;
}

export function isViewMode(mode) {
  return mode === COMPONENT_MODES.viewMode;
}

export function isAddNewMode(mode) {
  return mode === COMPONENT_MODES.addNewMode;
}

export const getVariantCombiNationName = (attribute) => {
  return (
    attribute.map((variant, variantIndex) => (
      <span className="capitalize" key={variant.value}>{" "}{variant.value} {variantIndex !== attribute.length - 1 ? "-" : " "}&nbsp;    </span>
    ))
  );
}

/**
 * This function will filter object from another object
 * @param {*} objectToFilter 
 * @param {*} targetObject 
 */
export const filterObject = (objectToFilter, targetObject) => {
  Object.keys(cloneDeep(objectToFilter))
    .filter(key => targetObject[key])
    .reduce((obj, key) => {
      obj[key] = objectToFilter[key];
      return obj;
    }, {});
}

/**
 * This function will parse to float
 * @param {*} inputVal
 */
export const parseFloatValue = (inputVal) => {
  let floatVal = parseFloat(inputVal);
  if (isNaN(floatVal)) return;
  return floatVal;
}


/**
 * This function will parse int value
 * @param {*} inputVal
 */
export const parseIntValue = (inputVal) => {
  let intVal = parseInt(inputVal);
  if (isNaN(intVal)) return;
  return intVal;
}

/**
 * 
 * @param {*} channelDefId 
 * @param {*} groupId 
 * @returns unique channelId using channelDefId and groupId
 */
export const getChannelId = (channelDefId, groupId) => {
  const allChannelsData =
    store.getState().businessReducer.allChannelsData || {};
  let channel = allChannelsData.find(
    (channel) =>
      channel.channelDefId === channelDefId && channel.groupId === groupId
  );
  return channel?.channelId;
};

/**
 * @param {*} branchList
 * @returns branches that are in active state
 */
export const filterInactiveBranches = (branchList = []) => {
  const clonedBranchList = cloneDeep(branchList);
  let filteredBranches = clonedBranchList.filter((branchData) => branchData.status === BRANCH_STATUS_MAP.ACTIVE);
  return filteredBranches;
}

/**
 * @param {*} categorylist
 * @returns subcategories map
 */
export function getSubcatMap(catList = []) {
  const subcategoriesWithName = {};
  const subCats = catList.reduce((subcats, category) => {
    (category.subCategories || []).map(subcat=> {
        subcats[subcat.mid] = subcat;
        subcategoriesWithName[subcat.name] = subcat;
    })
    return subcats;
  }, {});
  return { subcategories: subCats, subcategoriesWithName };
}